import React, { Component, Fragment } from "react";
import { isMobileApp } from "../../../actions/Util";
import ImageButton from "./ImageButton";
import Button from "./Button";
import "./Window.css";
import Icon from "./Icon";

class Window extends Component {

  renderCloseButton() {
    return (
      <div className="window-close-btn">
        <ImageButton
          type="remove"
          onClick={() => this.props.onClose()}
        />
      </div>
    );
  }
    getWindowWidth() {

    if (!this.props.hasOwnProperty("size")) {
      return "500px";
    }

    switch (this.props.size) {

      case "small":
        return "300px";

      case "large":
        return "800px";

      default:
        return "500px";
    }
  }

  renderButtons(className, fullWidth) {

    if (
      !this.props.hasOwnProperty("buttons") ||
      !this.props.buttons ||
      this.props.buttons.length === 0
    ) {
      return null;
    }

    return (
        <div
  style={
    fullWidth
      ? undefined
      : {
          width: this.props.hasOwnProperty("width")
            ? this.props.width
            : this.getWindowWidth()
        }
  }
  className={className}
>

        <div className="left" style={{ display: "flex", gap: "5px" }}>
          {this.props.buttons
            .filter(function (b) {
              return b.Align === "left";
            })
            .map((b, i) => (
              <Button
                key={i}
                type={b.Type}
                text={b.Text}
                processing={this.props.processing}
                onClick={() => {

                  if (this.props.hasOwnProperty("onButtonClick")) {
                    this.props.onButtonClick(b.Text);
                  }

                }}
              />
            ))}
        </div>

      <div className="right" style={{ display: "flex", gap: "5px", justifyContent: "flex-end" }}>
          {this.props.buttons
            .filter(function (b) {
              return b.Align === "right";
            })
            .map((b, i) => (
              <Button
                key={i}
                type={b.Type}
                text={b.Text}
                processing={this.props.processing}
                onClick={() => {

                  if (this.props.hasOwnProperty("onButtonClick")) {
                    this.props.onButtonClick(b.Text);
                  }

                }}
              />
            ))}
        </div>

      </div>
    );
  }




  /* ---------- DESKTOP SLIDE ---------- */

  renderDesktopSlide() {

    return (
      <Fragment>

        <div
          className="window-slide-overlay"
          onClick={() => this.props.onClose()}
        />

        <div className="window-slide">

          <div className="window-slide-container">

            <div className="window-slide-header primary-gradient">

              <div className="window-slide-title">
                {this.props.header}
              </div>

   <span
  className="window-slide-close"
  onClick={() => this.props.onClose()}
  style={{ color: "#fff" }}
>
  <Icon type="remove" />
</span>

            </div>

            <div
              className="window-slide-content"
               style={{
    width: this.getWindowWidth(),
       padding: this.props.padding ? this.props.padding : undefined,
         overflowY: this.props.overflowHidden ? "hidden" : "auto"
  }}
            >
              {this.props.children}
            </div>

            {this.renderButtons("window-slide-footer")}

          </div>

        </div>

      </Fragment>
    );
  }


  /* ---------- DESKTOP MODAL ---------- */

  renderDesktopModal() {

    return (
      <Fragment>

        <div
          className="window-overlay"
          onClick={() => {

            if (!this.props.hideClose) {
              this.props.onClose();
            }

          }}
        />

        <div
          className="window"
          style={{
            width: this.props.hasOwnProperty("width")
              ? this.props.width
              : this.getWindowWidth(),

            minHeight: this.props.hasOwnProperty("height")
              ? this.props.height
              : "auto"
          }}
        >

          {!this.props.hideClose && this.renderCloseButton()}

          <div className="window-container">

            {this.props.header && this.props.header !== "" && (

              <div className="window-header">

                <div className="window-header-title">
                  {this.props.header}
                </div>

              </div>

            )}

            <div className="window-content">

              {this.props.children}

            </div>

            {this.renderButtons("window-footer")}

          </div>

        </div>

      </Fragment>
    );
  }



  /* ---------- MOBILE FULL ---------- */

  renderMobileFull() {

    return (
      <Fragment>

        <div className="window-overlay window-overlay-white-background" />

        <div className="window-mobile" role="dialog" aria-modal="true">

          <div className="window-container">

            <div className="window-header-mobile">

              {!this.props.hideClose && (
                <ImageButton
                  type="leftarrow"
                  label="back"
                  onClick={() => this.props.onClose()}
                />
              )}

              <div className="window-header-title-mobile">
                {this.props.header}
              </div>

            </div>


            <div className="window-content-mobile">

              {this.props.children}

            </div>


            {this.renderButtons("window-footer-mobile", true)}

          </div>

        </div>

      </Fragment>
    );
  }



  /* ---------- MOBILE MODAL ---------- */

  // Bottom sheet, matches ActionSheet. choiceList shows the body's buttons as rows
  renderMobileModal() {

    return (
      <Fragment>

        <div
          className="row-sheet-overlay"
          onClick={() => {

            if (!this.props.hideClose) {
              this.props.onClose();
            }

          }}
        />

        <div
          className={"phone-sheet" + (this.props.choiceList ? " phone-sheet--list" : "")}
          role="dialog"
          aria-modal="true"
        >

          <div className="row-sheet-handle" />

          <div className="phone-sheet-header">

            <div className="phone-sheet-title">
              {this.props.header}
            </div>

            {!this.props.hideClose && (
              <button
                type="button"
                className="phone-sheet-close"
                aria-label="Close"
                onClick={() => this.props.onClose()}
              >
                <Icon type="remove" />
              </button>
            )}

          </div>

          <div className="phone-sheet-body">

            {this.props.children}

          </div>

          {this.renderButtons("window-footer-mobile", true)}

        </div>

      </Fragment>
    );
  }



  /* ---------- MAIN ---------- */

  render() {

    if (!isMobileApp() && this.props.slide) {
      return this.renderDesktopSlide();
    }

    if (!isMobileApp() && !this.props.slide) {
      return this.renderDesktopModal();
    }

    if (isMobileApp() && (this.props.modal || this.props.choiceList)) {
      return this.renderMobileModal();
    }

    return this.renderMobileFull();
  }

}

export default Window;